module.exports = __webpack_public_path__ + "static/media/Smarthome Service Diagram.8d8e1390.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/smartinsure/Smarthome Service Diagram.png
// module id = 629
// module chunks = 0